import React from "react";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { Helmet } from "react-helmet-async";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import PublicPageLayout from "./PublicPageLayout";
import { getPublicSiteSx } from "./publicSiteStyles";
import { FAQ_ITEMS } from "./siteData";

export default function FaqPage() {
  const theme = useTheme();
  const sx = React.useMemo(() => getPublicSiteSx(theme), [theme]);

  const faqSchema = React.useMemo(
    () =>
      JSON.stringify({
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: FAQ_ITEMS.map((item) => ({
          "@type": "Question",
          name: item.question,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.answer,
          },
        })),
      }),
    []
  );

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{faqSchema}</script>
      </Helmet>
      <PublicPageLayout
        eyebrow="FAQ"
        title="Answers to the questions players ask before they commit."
        description="Get clear answers about verification, reputation, memberships, and how Ouro approaches competitive matchmaking."
        mapBackground
      >
        <Box sx={sx.section}>
          <Box sx={sx.sectionHeader}>
            <Typography sx={sx.sectionTitle}>FAQ.</Typography>
          </Box>
          <Box sx={sx.faqList}>
            {FAQ_ITEMS.map((item) => (
              <Box key={item.question} sx={sx.faqCard}>
                <Typography sx={sx.faqQuestion}>{item.question}</Typography>
                <Typography sx={sx.faqAnswer}>{item.answer}</Typography>
              </Box>
            ))}
          </Box>
        </Box>

        <Box sx={sx.callout}>
          <Typography sx={sx.sectionCopy}>
            If you want the full picture, start with how Ouro works or compare the
            plans side by side before creating your account.
          </Typography>
          <Box
            sx={{
              mt: 3,
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 1.5,
            }}
          >
            <Button component={Link} to="/how-it-works" variant="contained" sx={sx.primaryButton}>
              See how Ouro works
            </Button>
            <Button component={Link} to="/pricing" variant="outlined" sx={sx.secondaryButton}>
              Compare plans
            </Button>
          </Box>
        </Box>
      </PublicPageLayout>
    </>
  );
}
